import React from 'react'
import LazyLoad, { type LazyLoadProps } from 'react-lazyload'

function withLazyLoad<T>(lazyLoadOptions: LazyLoadProps) {
  return (Component: React.ComponentType<T>) => {
    return (props: T) => {
      return (
        <LazyLoad {...lazyLoadOptions}>
          <Component {...props} />
        </LazyLoad>
      )
    }
  }
}

export default withLazyLoad
